import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const receivedMessages = defineMessages({
  required: {
    id: 'spanish.orders.receive.receivedQuantity.required',
    defaultMessage: 'La cantidad recibida es requerida'
  }
})
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
export const schema = (intl): TSFixMe => {
  return yup.object().shape({
    items: yup.array().of(
      yup.object().shape({
        received: yup.string().required(intl.formatMessage(receivedMessages.required))
      })
    )
  })
}
